import CloseIcon from '@mui/icons-material/Close'
import { AlertIconModal } from '../../../Models'
import './Alert.scss'

const Alert: React.FC<AlertIconModal> = ({
  Icon,
  type = 'success',
  content,
  handleClose,
}: AlertIconModal) => {
  return (
    <div className={`alert ${type}`}>
      <div>{Icon && <Icon />}</div>
      <div>{content}</div>
      <button
        className='mb-auto border-none transparent-background br-4'
        data-testid='alert-close__testid'
        onClick={handleClose}
      >
        <CloseIcon />
      </button>
    </div>
  )
}

export default Alert
